import React from 'react'
import { connect } from 'react-redux'
import { Grid, Segment, Input } from 'semantic-ui-react'
import styled from 'styled-components'
import { LKHeader } from 'loankeeper-common/components'
import { getPending } from 'loankeeper-common/helpers/SimpleFetchManager'
import { translate } from 'loankeeper-common/helpers'
//@ts-ignore
import LKModal, { actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import { PIN_CODE_MODAL } from 'shared/Modals/ValidatePinCodeModal'
//@ts-ignore
import { Container, FakeInput, GridContainer, SegmentGroup, ComponentContainer } from 'shared/StyledComponents'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'

import { translateLabel, translateCmd, translateBase, icon } from '../helpers'
import PhysicalInfoModals from './PhysicalInfoModals'
import { validationPinCodeFetcher } from '../constants'
import { ClientDetailsData, ClientDetailsTabProps, ThirdSegmentGroupPropTypes } from '../types'
import { PermissionsServerData, SendNewPinSMSParams } from '@lk/api'
import { sendNewPinSMS } from 'src/store/client'
import { AppDispatch } from 'src/store/index.d'

const LKHeaderNoWrap = styled(LKHeader)`
  white-space: nowrap;
`

class PhysicalSecond extends React.Component<ClientDetailsTabProps, { code: string }> {
  handleConfirm = (code: string) => {
    this.setState({ code })
  }

  render() {
    const { data } = this.props
    return (
      <Container>
        <SegmentGroup>
          <PhysicalInfoModals onConfirm={this.handleConfirm} />

          <Segment.Group>
            <Segment>
              <GridContainer>
                <Grid columns={6}>
                  <Grid.Row verticalAlign="middle">
                    <Grid.Column textAlign="right">{translateLabel('marital_status_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.MaritalStatus}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('job_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.Employment}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('native_language_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.NativeLanguage}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row verticalAlign="middle">
                    <Grid.Column textAlign="right">{translateLabel('education_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.Education}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('job_position_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.JobPosition}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('religion_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.Religion}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row verticalAlign="middle">
                    <Grid.Column textAlign="right">{translateLabel('health_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.Health}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('profession_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.Profession}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('race_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.Race}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row verticalAlign="middle">
                    <Grid.Column textAlign="right">{translateLabel('nationality_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.Nationality}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('income_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.Income}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('caste_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.Caste}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row verticalAlign="middle">
                    <Grid.Column textAlign="right">{translateLabel('smspref_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.SMSPref}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('expenses_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.Expenses}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('land_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.Land}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row verticalAlign="middle">
                    <Grid.Column textAlign="right">{translateLabel('cra_citizenship')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.Citizenship}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('kyc_valid_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.KYCValidity}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('dwelling_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.Dwelling}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row verticalAlign="middle">
                    <Grid.Column textAlign="right">{translateLabel('secondary_citiz_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.Citizenship2}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('statuslevel_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.StatusLevel}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('iban_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.IBANAccNo}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row verticalAlign="middle">
                    <Grid.Column textAlign="right">{translateLabel('autocover_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.AutoCoverPref}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('client_not')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.ClientNotClientFlagTitle}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('reg_ip')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.RegIP}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row verticalAlign="middle">
                    <Grid.Column textAlign="right">{translateLabel('pep')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.PEPFlagTitle}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('specialneedsflag_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.SpecialNeeds}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('amlindustry_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.AMLIndustry}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </GridContainer>
            </Segment>

            <Segment>
              <GridContainer>
                <Grid columns={6}>
                  <Grid.Row verticalAlign="middle">
                    <Grid.Column textAlign="right">{translateLabel('contact_person1')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.ContactPerson1}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('contact_person2')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.ContactPerson2}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('workplace')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.WorkPlace}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row verticalAlign="middle">
                    <Grid.Column textAlign="right">{translateLabel('contact_phone1')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.ContactPhone1}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('contact_phone2')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.ContactPhone2}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>

                    <Grid.Column textAlign="right">{translateLabel('salary_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          <LKHeader size="small">{data.RegFee}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row verticalAlign="middle">
                    <Grid.Column textAlign="right">{translateLabel('passphrase_t')}</Grid.Column>

                    <Grid.Column>
                      <FakeInput>
                        <Segment>
                          {/* @ts-ignore */} {/* need checking. Makho */}
                          <LKHeader size="small">{data.PassPhrase}</LKHeader>
                        </Segment>
                      </FakeInput>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </GridContainer>
            </Segment>
            {/* @ts-ignore */}
            <EnhancedThirdSegment data={data} code={this.state ? this.state.code : ''} />
          </Segment.Group>
        </SegmentGroup>
      </Container>
    )
  }
}

//@ts-ignore
PhysicalSecond.config = {
  title: () => translateBase('tb_ind_2'),
  name: 'general1',
  component: PhysicalSecond,
  api: 'base',
  icon: icon('tb_ind_2'),
}

@withConstantPermissions()
class ThirdSegmentGroup extends React.Component<ThirdSegmentGroupPropTypes> {
  data: ClientDetailsData
  openPinCodeValidationModal: () => void
  openNewPinConfirmation: () => void
  permissions: PermissionsServerData
  permission: 'CLIENT_NEW_PINCODE'

  constructor(props: ThirdSegmentGroupPropTypes) {
    super(props)
    this.data = this.props.data
    this.openPinCodeValidationModal = this.props.openPinCodeValidationModal
    this.openNewPinConfirmation = this.props.openNewPinConfirmation
    this.permissions = this.props.permissions
    this.permission = 'CLIENT_NEW_PINCODE'
  }

  handleSendSmsConfirm = async () => {
    // Client.sendNewPinSMS(this.data.ID, this.data.HashSum_ClientID_, this.data.CellPhone)

    //UPDATED API REQUEST client_oper_api page: newpincode
    try {
      const result = await this.props.sendNewPinSms({
        ID: this.data.ID,
        hash: this.data.HashSum_ClientID_,
        phoneNumber: this.data.CellPhone,
      })
      if (sendNewPinSMS.rejected.match(result)) {
        this.props.openError(result.payload as string)
      }
    } catch (error) {
      console.log(error)
    }
  }

  render() {
    return (
      <Segment>
        <GridContainer>
          <Grid>
            <Grid.Row verticalAlign="middle" />

            <Grid.Row verticalAlign="middle" />

            <Grid.Row verticalAlign="middle" />

            <Grid.Row verticalAlign="middle">
              <Grid.Column width={4} textAlign="right">
                {translateLabel('pin')}
              </Grid.Column>
              <Grid.Column width={this.permissions[this.permission] ? 2 : 1}>
                {this.permissions[this.permission] && (
                  <div style={{ display: 'flex' }}>
                    <Input fluid placeholder="****" value={this.props.code} style={{ flex: 1 }} disabled />
                    <LKButton alias="key" onClick={this.openPinCodeValidationModal} />
                  </div>
                )}
                {!this.permissions[this.permission] && (
                  <ComponentContainer input>
                    <Input fluid placeholder="****" disabled value={this.props.code} />
                  </ComponentContainer>
                )}
              </Grid.Column>
              <Grid.Column textAlign="right" width={3} />
              <Grid.Column textAlign="right" width={2}>
                {translateLabel('mcl')}
              </Grid.Column>
              <Grid.Column width={this.permissions[this.permission] ? 4 : 1}>
                <div className="u-flex" style={{ height: 'auto' }}>
                  <FakeInput className="u-fluid">
                    <Segment>
                      <LKHeaderNoWrap size="small">{this.data.MCLEnabledT}</LKHeaderNoWrap>
                    </Segment>
                  </FakeInput>
                  <LKButton
                    alias="globe"
                    onClick={this.openNewPinConfirmation}
                    name="SendNewPinConfirmation"
                    permission={this.permission}
                  >
                    {translateCmd('new_passcode')}
                  </LKButton>
                  <LKModal.Confirmation name="SendNewPinConfirmation" onConfirm={this.handleSendSmsConfirm} />
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </GridContainer>
      </Segment>
    )
  }
}

//@ts-ignore
PhysicalSecond.defaultProps = {
  data: {},
}

const getPinCodeValidationPending = (state) => getPending(validationPinCodeFetcher)(state) === true

const EnhancedThirdSegment = connect(
  (state) => ({
    pinCodeValidationPending: getPinCodeValidationPending(state),
  }),
  (dispatch: AppDispatch) => ({
    openPinCodeValidationModal: () => dispatch(LKModalActions.open({ name: PIN_CODE_MODAL })),
    openNewPinConfirmation: () =>
      dispatch(
        LKModalActions.openConfirmation('SendNewPinConfirmation', {
          message: translate('LKMESSAGE-CONFIRM_CLIENT_NEW_PINCODE'),
        }),
      ),
    sendNewPinSms: (params: SendNewPinSMSParams) => dispatch(sendNewPinSMS(params)),
    openError: (message: string) => dispatch(LKModalActions.openError(message)),
  }),
)(ThirdSegmentGroup)

export default PhysicalSecond
